var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.98 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance_Local_Outreach-icon",
    "data-name": "Compliance Local Outreach-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance_Local_Outreach-icon-2",
    "data-name": "Compliance Local Outreach-icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.31,1.6a5.08,5.08,0,0,1,5.07,5.07V33.33a5.07,5.07,0,0,1-5.07,5.07H6.67A5.08,5.08,0,0,1,1.6,33.33V6.67A5.08,5.08,0,0,1,6.67,1.6H33.31m0-1.6H6.67A6.67,6.67,0,0,0,0,6.67V33.33A6.67,6.67,0,0,0,6.67,40H33.31A6.67,6.67,0,0,0,40,33.33V6.67A6.67,6.67,0,0,0,33.31,0",
    fill: "#0e265e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.91,32.24a7.22,7.22,0,0,1-6.24-10.85A7.22,7.22,0,1,1,21.74,32,7.25,7.25,0,0,1,19.91,32.24Zm0-13.52a6.43,6.43,0,0,0-1.62.21,6.3,6.3,0,0,0-4.49,7.7A6.3,6.3,0,0,0,25.35,28.2,6.25,6.25,0,0,0,26,23.42h0a6.31,6.31,0,0,0-6.09-4.7Z",
    fill: "#0e265e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.29,
    y: 27.52,
    width: 0.91,
    height: 9.06,
    transform: "matrix(0.6, -0.8, 0.8, 0.6, -14.12, 36)",
    fill: "#0e265e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.38,35.57a.82.82,0,0,1-.49-.16l-4.48-3.33a.82.82,0,0,1,1-1.32l4.48,3.33A.82.82,0,0,1,33,35.24.81.81,0,0,1,32.38,35.57Z",
    fill: "#0e265e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09,25.71A13.71,13.71,0,0,1,9.33,8.53l.34-.36.33.36a12.89,12.89,0,0,0,4,2.93l.36.17-.12.38a21.91,21.91,0,0,0-.9,5.9l-.91,0a23.23,23.23,0,0,1,.83-5.77,14.2,14.2,0,0,1-3.59-2.6,12.77,12.77,0,0,0-.84,15.67Z",
    fill: "#658bce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,12.51l-.48-.22A14.11,14.11,0,0,1,9.33,9.16l-.28-.32.28-.31a14,14,0,0,1,8.48-4.34L19.07,4,18.2,5A17.78,17.78,0,0,0,14.25,12ZM10.3,8.84a12.64,12.64,0,0,0,3.24,2.39,19,19,0,0,1,3.15-5.92A13,13,0,0,0,10.3,8.84Z",
    fill: "#658bce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,25.71l-.75-.52a12.79,12.79,0,0,0-.85-15.67,13.71,13.71,0,0,1-3.49,2.54A23.06,23.06,0,0,1,26.79,18h-.91A21.72,21.72,0,0,0,25,12l-.11-.38.35-.17a12.75,12.75,0,0,0,3.91-2.88l.33-.35.34.35A13.73,13.73,0,0,1,31,25.71Z",
    fill: "#658bce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.11,12.47,25,12A17.65,17.65,0,0,0,21,5L20.17,4l1.27.17a14,14,0,0,1,8.34,4.32l.29.31-.29.32a14,14,0,0,1-4.19,3.08ZM22.57,5.35a18.9,18.9,0,0,1,3.1,5.83,12.85,12.85,0,0,0,3.14-2.34A13.06,13.06,0,0,0,22.57,5.35Z",
    fill: "#658bce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.88,18a22.36,22.36,0,0,0-.77-5.53A13.68,13.68,0,0,1,20,13.61V15.7H19.1v-3h.46a12.91,12.91,0,0,0,5.64-1.3l.48-.23.15.51a22.47,22.47,0,0,1,1,6.29Z",
    fill: "#658bce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.35,17.91l-.91,0a22.58,22.58,0,0,1,.94-6.15l.15-.5.48.22a12.93,12.93,0,0,0,5.55,1.25H20v3H19.1V13.61a13.71,13.71,0,0,1-5-1.11A22.28,22.28,0,0,0,13.35,17.91Z",
    fill: "#658bce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,13.62h-.45a14,14,0,0,1-5.94-1.33l-.35-.17.11-.38a18.68,18.68,0,0,1,4.16-7.41l.11-.12.16,0a14.43,14.43,0,0,1,1.75-.12H20Zm-5.64-2A13,13,0,0,0,19.1,12.7V5a9.91,9.91,0,0,0-1,.09A17.64,17.64,0,0,0,14.37,11.62Z",
    fill: "#658bce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.56,13.62H19.1V4.07h.46a13.44,13.44,0,0,1,1.88.14l.16,0,.11.12a18.59,18.59,0,0,1,4.12,7.34l.12.38-.36.17A13.79,13.79,0,0,1,19.56,13.62ZM20,5V12.7a12.86,12.86,0,0,0,4.83-1.12,17.53,17.53,0,0,0-3.69-6.49C20.74,5,20.36,5,20,5Z",
    fill: "#658bce"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLo);
export default __webpack_public_path__ + "static/media/lo.cb38342a36d99cf241db378910267a2b.svg";
export { ForwardRef as ReactComponent };